import React, { useEffect, useState } from 'react'
import { View, StyleSheet, Text } from 'react-native'

import client, { useClient } from '@sart/client'
import { useContent } from '@sart/content'
import { adaptive, colors, typography } from '@sart/styles'
import {
	Space,
	Button
} from '@sart/components'
import { updateNotifications, testID } from '@sart/utilities'

export default function NotificationError(props) {
	const { navigation, route } = props

	useEffect(() => {
    updateNotifications(client.cache.userId)
  }, [])

	const errorMessage = route.params?.errorMessage

	const content = useContent()

	return (
		<View style={styles.container}>
			<View style={styles.internal}>
				<Text style={styles.text}>{errorMessage}</Text>
				<Space height={24}/>
				<Button
					title={content.inbox.backToInbox}
					onPress={() => navigation.navigate('Inbox')}
					titleStyle={{...typography.extrabold, fontSize: 18, color: colors.white}}
					style={styles.button}
					{...testID('BackToInbox')}
				/>
			</View>
		</View>
	)

}
const styles = StyleSheet.create({
  container: {
    flex: 1,
		backgroundColor:colors.white,
		alignItems:"center",
    ...adaptive.wrapperPadding
  },
	internal: {
		flex:1,
		justifyContent:'center',
		
	},
	text: {
		marginHorizontal:44,
		color:colors.feature,
		fontSize:16,
		lineHeight: 24,
		textAlign:'center',
		...typography.bold
	},
	button: {
		marginHorizontal:32,
		backgroundColor: colors.srDarkGreen
	}
})